import { clearCachedCurrentToken } from './cache';
import { getCurrentToken } from './getCurrentToken';
import handleFetchErrors from '../helpers/handleFetchErrors';

const handle401 = (response: Response) => {
  if (response.status === 401) {
    clearCachedCurrentToken();
    // When getting 401, we want to try and get a new token.
    // getCurrentToken would redirect the user to the needed login URL if needed.
    // If the new login was successful (should happen rarely) - we want to return the response with error and let the consumer decide whether to make another request.
    return getCurrentToken().then(() => response);
  }
  return response;
};

export const fetchResponseWithToken = (
  url: RequestInfo,
  fetchData?: RequestInit,
): Promise<Response> => {
  return getCurrentToken()
    .then(({ accessToken }) =>
      fetch(url, {
        ...fetchData,
        headers: {
          ...(fetchData && fetchData.headers),
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    )
    .then(handle401);
};

export const fetchWithToken = <T>(
  url: RequestInfo,
  fetchData?: RequestInit,
): Promise<T> => {
  return fetchResponseWithToken(url, fetchData)
    .then(handleFetchErrors)
    .then((res) => res.text()) // check if res body exists before trying to json parse it - to avoid parsing errors
    .then((text) => (text ? JSON.parse(text) : {}));
};
